import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import {
  CardButtonComponent,
  CardButtonConfig,
} from '@shared/components/card-button/card-button.component';

@Component({
  selector: 'app-auth-select-method',
  standalone: true,
  imports: [CommonModule, TranslateModule, CardButtonComponent],

  templateUrl: './select-method.component.html',
})
export class AuthSelectMethodComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  accountActivationConfig!: CardButtonConfig;
  loginConfig!: CardButtonConfig;

  constructor(
    private router: Router,
    private translate: TranslateService
  ) {
    this.rebuildConfigs();
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.rebuildConfigs());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goAccountActivation(): void {
    this.router.navigateByUrl('/auth/account-activation');
  }

  goLogin(): void {
    this.router.navigateByUrl('/auth/login');
  }

  private rebuildConfigs(): void {
    this.accountActivationConfig = {
      title: this.translate.instant('auth.selectMethod.activationTitle'),
      description: this.translate.instant(
        'auth.selectMethod.activationDescription'
      ),
      icon: 'assets/icons/key.svg',
    };

    this.loginConfig = {
      title: this.translate.instant('auth.selectMethod.loginTitle'),
      description: this.translate.instant('auth.selectMethod.loginDescription'),
      icon: 'assets/icons/login.svg',
    };
  }
}
